<template>
  <div class="view view-ar">
    <single-feed v-if='showingPhotoId !== null' :photoid="showingPhotoId" v-on:close="showingPhotoId = null"></single-feed>
    <div style='position: fixed; top: 0px; left: 0px; z-index: 999; width: 100%;'>
      <infobox v-if="infotext !== ''" v-bind:text="infotext"></infobox>
    </div>
    <div class="ar">
      <div class="overlay">
      </div>
      <div id="argon">
        <div class='inside-closer' v-on:click="close">✖</div>
        <div class="camera" id="camera"><video id="camera-video" autoplay></video></div>
        <canvas id='argon-canvas' v-on:click="clickHandler"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Argame from '@/classes/ArgameEx'
import infobox from '@/components/Infobox'
import db from '@/classes/Db'
import singleFeed from '@/components/singleFeed'
var game = false

export default {
  name: 'arex',
  data () {
    return {
      msg: 'AR',
      app: '',
      closestSpot: null,
      shouldLoad: true,
      currentArea: 'exhibit',
      winnerPhotos: [],
      showingPhotoId: null,
      hasShownWarning: false
    }
  },
  computed: {
    infotext () {
      let html = ''
      html = 'Välkommen till utställningen!<h6>Om du är i Kungsträdgården så kan du titta upp mot himmelen och se alla vinnarbilderna från Exhibition Stockholm 2017. Klicka på bilderna för en närmare titt.'
      return html
    },
    userLocation () {
      return this.$store.state.userLocation
    },
    spots () {
      return this.$store.state.spots
    },
    atSpot () {
      return this.$store.state.atSpot
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    close () {
      console.log('should go to start.')
      window.location.href = 'https://game.exhibitionstockholm.se'
    },
    getAllWinners (callback) {
      db.database().ref('finalwinners').once('value', (snapshot) => {
        //  this.winnerPhotos = snapshot.val()
        snapshot.forEach((child) => {
          this.winnerPhotos.push(child.val())
        })
        this.photosLoaded = true
        typeof callback === 'function' && callback(this.winnerPhotos)
      })
    },
    hasGetUserMedia () {
      return !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia)
    },
    startCamera () {
      //  console.log(cameras)
      //  Get rear facing camera if available
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        let videoDevices = []
        devices.forEach(function (device) {
          //  console.log(device.kind + ': ' + device.label + ' id = ' + device.deviceId)
          if (device.kind === 'videoinput') {
            videoDevices.push(device.deviceId)
          }
        })
        let choosenId = videoDevices[0]
        if (videoDevices[1]) {
          choosenId = videoDevices[1]
        }
        let constraints = {deviceId: { exact: choosenId }, video: {mandatory: {minWidth: 1920, minHeight: 1080}}}
        return constraints
      }).then((constraints) => {
        var errorCallback = function (e) {
          //  console.log('Reeeejected!', e)
        }
        navigator.getUserMedia({video: constraints, audio: false}, function (localMediaStream) {
          var video = document.getElementById('camera-video')
          video.src = window.URL.createObjectURL(localMediaStream)
          video.onloadedmetadata = function (e) {
            //  console.log('camera meta', e)
          }
        }, errorCallback)
      })
    },
    userOS () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/windows phone/i.test(userAgent)) {
        return true
      }
      if (/android/i.test(userAgent)) {
        return true
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return false
      }
      return false
    },
    addSpots (spots, game) {
      var self = this
      var userCurrentLocation = {
        latitude: self.userLocation.lat,
        longitude: self.userLocation.lng
      }
      let areakey = this.currentArea
      //  console.log('adding spots ', spots)
      game.renderThings(areakey, userCurrentLocation, spots, window.arEngine.scene, false)
    },
    clickHandler (event) {
      let self = this
      game.clickHandler(event, window.arEngine.scene, window.arEngine.camera, window.arEngine.raycaster, window.arEngine.mouse, window.arEngine.renderer, (object) => {
        if (object.length > 0) {
          self.showingPhotoId = object[0].object.name
          //  console.log(self.showingPhotoId)
          /* let objectName = object[0].object.name
          let buttonType = objectName.split('_')[1]
          let spotName = objectName.split('_')[0]
          if (buttonType === 'challenge') {
            this.$store.dispatch('setAtSpot', {spotname: spotName, distance: object[0].distance})
            this.$store.commit('showingPhotoUpload', true)
          } else if (buttonType === 'view') {
            this.$store.dispatch('setAtSpot', {spotname: spotName, distance: object[0].distance})
          } else {
            this.$store.dispatch('setAtSpot', {spotname: null, distance: 0})
          } */
        } else {
          //  this.$store.dispatch('setAtSpot', {spotname: null, distance: 0})
        }
      })
    }
  },
  watch: {
    closestSpot: function (val) {
      //  If first time show when val.dist < 60
    },
    userLocation: function (val) {
      if (game) {
        var userCurrentLocation = {
          latitude: val.lat,
          longitude: val.lng
        }
        /*
        console.log('Ny location', userCurrentLocation)
        console.log('Updating spots ', this.spots) */
        game.locationUpdateThings([], userCurrentLocation)
        //  console.log('new location', userCurrentLocation)
      }
    },
    currentArea: function (val) {
      //  console.log('currentArea', val)
      if (val === null) {
        //  let html = 'Du befinner dig inte i ett fotoområde! <h6>Glasögonen fungerar endast när du befinner dig i ett utav de gröna fälten på kartan. Ta dig till ett fotoområde!</h6>'
        //  this.$store.commit('interupt', html)
        //  this.$router.push('/map')
      }
    }
  },
  beforeMount () {
    /* if (this.$store.state.currentArea === null) {
      this.shouldLoad = false
    } else {
      this.shouldLoad = true
    } */
    this.shouldLoad = true
  },
  mounted () {
    this.$store.commit('interupt', this.infotext)
    this.$store.commit('setNeedsReload', true)
    let canShowCamera = this.hasGetUserMedia()
    if (!this.userOS()) {
      canShowCamera = false
    }
    if (canShowCamera === false) {
      //  alert('kan inte visa kameran')
      //  return
    } else {
      this.startCamera()
    }
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Ar - Utställning')
    }
    this.$store.commit('setWasAtAr', true)
    this.$store.commit('changeShowMenu', true)
    game = new Argame()
    var userCurrentLocation = {
      latitude: this.userLocation.lat,
      longitude: this.userLocation.lng
    }
    window.arEngine.onMount(canShowCamera)
    let areakey = this.currentArea
    this.getAllWinners((winners) => {
      let showObj = !canShowCamera
      game.renderThings(areakey, userCurrentLocation, this.spots, window.arEngine.scene, showObj, winners, () => {
        //  console.log('added spots at mount', this.spots)
      })
    })
    window.arEngine.setUpdateEvent(game, (close) => {
      if (close.dist > 1200 && !this.hasShownWarning) {
        //  let html = 'Du verkar vara långt ifrån utställningen!<h6>Utställningen visas i Kungsträdgården, Stockholm.</h6>'
        this.hasShownWarning = true
        //  this.$store.commit('interupt', html)
      }
      //  this.closestSpot = close
    })
    window.addEventListener('compassneedcalibration', () => {
      let html = 'Din kompass behöver kalibreras!<h6>Rör din telefon i 8or ett par gånger.</h6>'
      this.$store.commit('interupt', html)
    })
  },
  beforeDestroy () {
    //  game.clearThings(window.arEngine.scene, window.arEngine.camera)
    //  game = false
    if (!window.arEngine) {
      window.arEngine.destroy()
    }
    this.$store.dispatch('setAtSpot', { spotname: null, distance: 0 })
    this.$store.commit('showingPhotoUpload', false)
  },
  components: { infobox, singleFeed }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.inside-closer {
  z-index: 99999;
}
.camera {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vw;
  background-color: #000;
  z-index: -1;
}
.camera video {
  height: 100vh;
}
#description {
    pointer-events: auto;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    padding: 10px;
    background-color:rgba(255,255,255,0.7);
    -webkit-backdrop-filter: blur(5px);
    position:absolute;
    bottom: 0px;
}
.argon-focus #description {
    transition: opacity 0.8s;
    visibility: visible;
    opacity: 1;
}
#argon-canvas {
  cursor: pointer;
  background-color: transparent;
}
#argon {
  background-color: transparent;
}
.argon-ui {
    display: none !important;
}
.spotview {
  z-index: 99;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.log {
    position: absolute;
    z-index: 999;
    padding: 20px;
    font-size: 16px;
}
.argon-no-focus #description {
    transition: visibility 0s linear 0.8s, opacity 0.8s;
    visibility: visible;
    opacity: 0;
}
.ar {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: transparent;
}
.ar .overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
  opacity: 1;
  color: #fff;
  font-size: 25px;
  width: 100%;
  text-align: center;
}
.overlay {
  pointer-events: none;
}
.ar .overlay .meter-box {
  display: inline-block;
  position: relative;   
  font-size: 25px;
  padding: 10px 15px;
  top: 100px;
  border: 0px solid #fff; 
}
.view-ar {
  background-color: green;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// Arex.vue?bcefe26a